import {default as chroma} from 'chroma-js'

export const isValid = (color: string) => chroma.valid(color)

export const hsl = (color: string) => chroma(color).hsl()

export const distance = (color1: string, color2: string) => chroma.deltaE(color1, color2)

export const contrast = (color1: string, color2: string) => chroma.contrast(color1, color2)
